import { useEffect } from 'react';
import { useScheduledEmails } from './scheduled-email-context';
import EmailCard from '../components/card/email-card';
import EmailListSkeleton from '../components/email-list-skeleton';
import PropTypes from 'prop-types';
import EmailEmptyState from '../components/email-empty-state';
import EmailControllerHeader from '../components/email-controller-header';
import { useIsFilterApplied } from '../utils/filter-search-helper';

const ScheduledEmailController = ({
  handleBulkSelect = () => {},
  selectedEmailAddresses = [],
  dateRange,
  selectedNames,
  selectedEmails,
}) => {
  const { updateFilters } = useScheduledEmails();
  const {
    scheduledEmails,
    loading,
    page,
    onPageChange,
    scheduledTotal,
    scheduledLimit,
    searchScheduled,
    hasEverHadData,
  } = useScheduledEmails();

  const isFilterApplied = useIsFilterApplied({ dateRange, selectedEmailAddresses, selectedNames });

  useEffect(() => {
    const fetchScheduledEmails = async () => {
      updateFilters({ dateRange, selectedEmailAddresses, selectedNames });
      if (isFilterApplied) {
        await searchScheduled({ dateRange, emailRecipients: selectedEmailAddresses, selectedNames });
      }
    };

    fetchScheduledEmails();
  }, [isFilterApplied, searchScheduled, dateRange, selectedEmailAddresses, selectedNames, page, updateFilters]);

  useEffect(() => {
    return () => {
      onPageChange(1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loading ? (
        <EmailListSkeleton />
      ) : (
        <>
          {scheduledEmails.length === 0 && (
            <EmailEmptyState type="scheduled" isFilterApplied={isFilterApplied && hasEverHadData} />
          )}
          {scheduledEmails.length > 0 && (
            <div className="email-controller-container">
              <EmailControllerHeader
                selectedCount={selectedEmails.length}
                totalCount={scheduledEmails.length}
                label="Scheduled"
                page={page}
                onPageChange={onPageChange}
                totalPages={Math.ceil(scheduledTotal / scheduledLimit)}
              />
              {!!scheduledEmails.length &&
                scheduledEmails.map((scheduledEmail) => (
                  <EmailCard key={scheduledEmail.id} email={scheduledEmail} handleBulkSelect={handleBulkSelect} />
                ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

ScheduledEmailController.propTypes = {
  handleBulkSelect: PropTypes.func,
  selectedEmails: PropTypes.array,
  dateRange: PropTypes.shape({
    from: PropTypes.instanceOf(Date),
    to: PropTypes.instanceOf(Date),
  }),
  selectedEmailAddresses: PropTypes.array,
  selectedNames: PropTypes.array,
};

export default ScheduledEmailController;
